import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { systemService } from "../../services/system.service";

const Contact = () => {
  const { t } = useTranslation(["marketing", "common"]);
  const [email, setEmail] = useState<string | null>(null);

  // The address is a CMS system setting, not locale copy — one address serves
  // both languages, and support routing changes without a redeploy. Until an
  // admin sets one the block is omitted entirely: a dead mailto: is worse than
  // no link, and the placeholder this replaced pointed at example.com, which
  // publishes no MX record.
  useEffect(() => {
    systemService
      .getSupportEmail()
      .then(setEmail)
      .catch(() => setEmail(null));
  }, []);

  return (
    <div data-testid="page-contact" className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="font-display text-3xl font-black">{t("contact.title")}</h1>
      <p className="mt-4 text-ink-soft">{t("contact.intro")}</p>
      {email && (
        <p className="mt-6">
          <span className="text-ink-soft">{t("contact.emailLabel")}: </span>
          <a href={`mailto:${email}`} className="font-bold text-teal-dark underline">
            {email}
          </a>
        </p>
      )}
    </div>
  );
};

export default Contact;
